/** @format */

import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  breakpoints: {
    sm: "481px",
    md: "769px",
    lg: "1160px",
    mx: "1160px"
  },
  fonts: {
    heading: `'Pretendard', sans-serif`,
    body: `'Pretendard', sans-serif`
  }
});

export default theme;
